import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom';

class ErrorMessage extends Component {
    constructor(props) {
        super(props);
    }

    getMessage() {
        let message = '';
        if (this.props.field3)
            try {
                message = this.props.errors[this.props.field1][this.props.field2][this.props.field3]
            } catch (e) {
                message = false
            }
        else if (this.props.field2)
            try {
                message = this.props.errors[this.props.field1][this.props.field2]
            } catch (e) {
                message = false
            }
        else if (this.props.field1)
            try {
                message = this.props.errors[this.props.field1]
            } catch (e) {
                message = false
            }
        return message;
    }

    render() {
        if (!this.getMessage()) {
            return <span id={this.props.anchor} />;
        }

        return (
            <div className={`error-message-div ${this.props.className ? this.props.className : ""}`} >
                <span id={this.props.anchor} style={{ color: 'red', fontSize: '12px', textDecoration: this.props.textDecoration }} title={this.props.title}>
                    {this.getMessage()}
                </span>
            </div>
        )
    }
}

export default withRouter(connect(
    state => ({
        errors: state.purchase.errors
    }),
    { }
)(ErrorMessage))



// WEBPACK FOOTER //
// ./src/components/purchase/error_message/ErrorMessage.jsx